module.exports = __webpack_public_path__ + "static/media/dropdown arrow.e12127c1.svg";